import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  FormsModule } from '@angular/forms';
import { Permissions } from 'src/app/permissions.enum';  
import { AuthService } from 'src/app/services/auth.service';
import { TranslationService } from 'src/app/services/translation.service';
import { QuestionsAndAnswersService } from 'src/app/services/questions-and-answers.service';
import { ExamFolderService } from 'src/app/services/exam-folder.service';
import { ExamService } from 'src/app/services/exam.service';
import { AudioService } from 'src/app/services/audio.service';

@Component({
  selector: 'app-questions-and-answers',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './questions-and-answers.component.html',
  styleUrls: ['./questions-and-answers.component.css'],
})
export class QuestionsAndAnswersComponent {

  Permissions = Permissions;  

  constructor(private qsService:QuestionsAndAnswersService , private examFolder: ExamFolderService,private examService: ExamService, public translationService: TranslationService, public audioService: AudioService,private authService: AuthService) {}
  
  qusetionBank: any[] = [];
  questionLangContent: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  TotalQuestions: number = 0;
  selectedQuestion: any;
  unitCount: any;
  questionTypes: string[] = ['MultiAnswers','MCQ', 'TF', 'MCQImages', 'RightOrWrongImage',  'RightOrWrongVideo', 'Ordering'];
  languagesList: any[] = [];
  filteredLanguagesList: any[] = [];
  QuestionLevels: any[] = [
    { id: 1, name: 'Very Easy' },
    { id: 2, name: 'Easy' },
    { id: 3, name: 'Medium' },
    { id: 4, name: 'Hard' }
  ];

  selectedQuestionType: string = '';
  showQuestionImage: boolean = false;
  showQuestionVideo: boolean = false;
  showAnswerText: boolean = false;
  showAddBTN: boolean = false;
  showRemoveBTN: boolean = false;
  showAnswerAudio: boolean = false;
  showAnswerVideo: boolean = false;
  showAnswerImage: boolean = false;
  selectedFormNumber: number = 1;

  searchText: string = '';
  searchFolder: string = '';
  searchUnit: string = '';
  searchType: string = '';
  searchLevel: string = '';

  showViewModal: boolean = false;
  showUpdateModal: boolean = false;
  showAddModal: boolean = false;

  folderDetails: any[] = [];
  selectedFolderUnits: any[] = [];

  UnitDTO: any = {
    UnitId: 0,
    UnitName: ''
  };
  
  FolderDTO: any = {
    ID: 0,
    CourseName: '',
    CourseUnitsCount: 0,
    UnitsDetails: []
  };
  
  AnswersDTO: any = [];

  formAddQuestion: any = {
    UnitID: 0,
    ParentQuestionID: null,
    QuestionText: null,
    QuestionType: null,
    Weightage: null,
    QuestionLevel: null,
    VideoLink: null,
    AudioLink: null,
    ImageLink: null,
    LanguageID: 0,
    FormNo: 0,
    IsActive: 1,
    CreatedBy: 0,
  };

  showDeleteModal: boolean = false;
  uploadedFileName: string | null = null;
  isUploading: boolean = false;
  getImageLink: string = 'https://exam.alarkkan.app/data/img/';
  getVideoLink: string = 'https://exam.alarkkan.app/data/vdo/';


  ngOnInit() {
    const sidebar = document.getElementById('sidebar');
    if (sidebar) {
      sidebar.style.height = '100%'; 
    }
    const modal = document.querySelector('.modal');
    const button = modal?.querySelector('button');

    if (modal && button) {
      modal.setAttribute('aria-hidden', 'true');
      button.blur();
    }
    this.getQuestionsBank();
    this.getExamFolders();
    this.getQuestionsCout();
    this.getLanguages();
  }

  hasPermission(permission: Permissions): boolean {
    return this.authService.hasPermission(permission);
  }

  getExamFolders() {
    this.examFolder.getFolders().subscribe((response) => {
        this.folderDetails = response.result[0] || [];
        this.FolderDTO = this.folderDetails.map((folder: any) => {
            let folderDTO = {
                ...this.FolderDTO,
                ID: folder["ID"],
                CourseName: folder["Course Name"],
                CourseUnitsCount: folder["Course Units Count"],
                UnitsDetails: [],
            };
            if (folder.UnitsDetails) {
                JSON.parse(folder.UnitsDetails).forEach((unit: any) => {
                    folderDTO.UnitsDetails.push({
                        ...this.UnitDTO,
                        UnitId: unit.UnitId,
                        UnitName: unit["Unit Name"],
                    });
                });
            }
            return folderDTO;
          });
    });
  }

  getQuestionsBank() {
    this.qsService.getQuestionsBank(this.currentPage, this.itemsPerPage).subscribe((response) => {
      this.qusetionBank = response?.result?.[0] || [];
    });
  }

  searchForItem(searchText: any) {
    this.qsService.searchForItem(searchText).subscribe((response) => {
      this.qusetionBank = response?.result?.[0] || [];
    });
  }
  
  getQuestionsCout() {
  this.qsService.getTotalQuestionsNumber().subscribe((response) => {
      this.TotalQuestions = response?.result?.[0]?.[0]?.TotalRecords || 0;
  });
  }

  getLanguages() {
    this.examService.getLanguageList().subscribe((response) => {
        this.languagesList = response.result[0].map((language: { LanguageName: any; ShortName: any; LanguageID: any }) => ({
          LanguageID : language.LanguageID,
          LanguageName: language.LanguageName,
          ShortName: language.ShortName
        }));

        const desiredLanguages = ["Arabic", "English", "Urdu (Pakistan)", "Bengali (Bangladesh)" , "Hindi (India)" , "Nepali (Nepal)" , "Malayalam" , "Tamil (India)" , "Filipino" , "Indonesian (Indonesia)" , "Turkish (Turkey)"];
        this.filteredLanguagesList = this.languagesList.filter(lang => desiredLanguages.includes(lang.LanguageName));
      },
    );
  }

  onFolderChange(event: any) {
    const selectedFolderName = event.target.value;
    const selectedFolder = this.FolderDTO.find(
      (folder: { CourseName: string }) => folder.CourseName === selectedFolderName
    );
  
    if (selectedFolder) {
      try {
        this.selectedFolderUnits = selectedFolder.UnitsDetails
          ? typeof selectedFolder.UnitsDetails === 'string'
            ? JSON.parse(selectedFolder.UnitsDetails)
            : selectedFolder.UnitsDetails
          : [];
      } catch (error) {
        this.selectedFolderUnits = [];
      }
    } else {
      this.selectedFolderUnits = [];
    }
  }  

  onQuestionTypeChange(event: any) {
    const selectedQuestionType = event.target.options[event.target.selectedIndex].text;
    this.selectedQuestionType = selectedQuestionType;

    if (selectedQuestionType === 'MultiAnswers'){
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = true;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }
    
    if (selectedQuestionType === 'MCQ'){ 
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    } 

    if (selectedQuestionType === 'TF'){ 
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: 'صح' },
        { AnswerID: 0, AnswerText: 'خطأ' }
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (selectedQuestionType === 'MCQImages'){
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
        { AnswerID: 0, AnswerText: '' },
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = true;
    }

    if (selectedQuestionType === 'RightOrWrongImage'){
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: 'التصرف صحيح' },
        { AnswerID: 0, AnswerText: 'التصرف خاطئ' }
      ];
      this.showQuestionImage = true;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (selectedQuestionType === 'RightOrWrongVideo'){
      this.AnswersDTO = [ 
        { AnswerID: 0, AnswerText: 'صحيح (ليس هناك خطأ في الفيديو)' },
        { AnswerID: 0, AnswerText: 'خطأ( يوجد خطأ في الفيديو)' }
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = true;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (selectedQuestionType === 'Ordering'){
      this.AnswersDTO = [ 
        { AnswerText: '' },
        { AnswerText: '' },
        { AnswerText: '' },
        { AnswerText: '' },
      ];
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = true;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }
  }
    
  isFormInvalid(): boolean {
    return !this.formAddQuestion.FolderName || 
            !this.formAddQuestion.FolderUnit || 
            !this.formAddQuestion.QuestionType || 
            !this.formAddQuestion.QuestionLevel || 
            !this.formAddQuestion.QuestionText || 
            this.AnswersDTO.length === 0 || 
            this.AnswersDTO.some((a: { AnswerText: any; }) => !a.AnswerText);

  }

  handleFileInput(event: Event, type: 'image' | 'video', answerIndex?: number) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const allowedTypes = type === 'image' 
        ? ['image/png', 'image/jpeg'] 
        : ['video/mp4', 'video/avi'];
        
      if (!allowedTypes.includes(file.type)) {
        return;
      }
      this.isUploading = true;
      this.uploadFile(file, type, answerIndex);
    }
  }
  
  uploadFile(file: File, type: 'image' | 'video', answerIndex?: number) {
    const apiType = type === 'image' ? 'img' : 'vdo';
  
    this.qsService.uploadImage(apiType, file).subscribe({
      next: (response) => {
        this.isUploading = false;
        if (response.success) {
          if (answerIndex !== undefined) {
            this.AnswersDTO[answerIndex][type === 'image' ? 'ImageLink' : 'VideoLink'] = response.filename;
          } else {
            this.formAddQuestion[type === 'image' ? 'ImageLink' : 'VideoLink'] = response?.filename || null;
            this.selectedQuestion[type === 'image' ? 'ImageLink' : 'VideoLink'] = response?.filename || null;
          }
        } else {
        }
      },
      error: (error) => {
        this.isUploading = false; 
      }
    });
  }
  
  viewQuestion(question: any) {
    this.selectedQuestion = { ...question };
    this.selectedQuestion.OriginalID = question.ID; 
    this.selectedQuestion.DisplayedQuestionID = question.ID; 
   
    if (question.Language !== 'Arabic' && this.questionLangContent.length > 0) {
      this.selectedQuestion.DisplayedQuestionID = this.questionLangContent[0].QuestionID;
    }

    if (this.selectedQuestion.Question !== null) {
      this.qsService.getAnswers(this.selectedQuestion.DisplayedQuestionID).subscribe((response) => {
        this.AnswersDTO = response?.result?.[0] || [];
     
        if (this.selectedQuestion.QuestionType === 'Ordering') {
          this.AnswersDTO = this.AnswersDTO.map((answer: any) => {
            const cleanedText = answer.AnswerText.trim();
            const splitText = cleanedText.match(/(?:\([^)]+\)|[^,])+/g)?.map((text: string) => text.trim()) || [];
            const splitImages = (answer.ImageLink || "").split(',').map((image: string) => image.trim());
        
            if (splitText[0].startsWith("Ordering Ordering")) {
              splitText[0] = splitText[0].replace("Ordering Ordering", "").trim();
            } else if (splitText[0].startsWith("Ordering")) {
              splitText[0] = splitText[0].replace("Ordering", "").trim();
            }
        
            return splitText.map((word: string, index: number) => ({
              AnswerID: answer.AnswerID + index,
              AnswerText: word,
              IsCorrect: answer.IsCorrect,
              ImageLink: splitImages[index] || null,
            }));
          }).flat();
        }
        
          this.showViewModal = true;
      });
    }
  }

  playAudio(text: string, language: string): void {
    language = this.filteredLanguagesList.find((lang: any) => lang.LanguageName === language)?.ShortName;
    this.audioService.textToAudio(text, language).subscribe({
      next: (audioBlob: Blob) => {
        const audioSrc = URL.createObjectURL(audioBlob);
        const audio = new Audio(audioSrc);
        audio.play()
      }
    });
  }
  
  AddModal() {
    this.formAddQuestion = {}
    this.showAddModal = true;
    this.AnswersDTO = [];
    this.selectedQuestionType = '';
  }
  
  AddQuestionItem() {
    this.selectedFolderUnits.forEach((unit: any) => {
      if (unit.UnitName === this.formAddQuestion.FolderUnit) {
        this.formAddQuestion.UnitID = unit.UnitId;
      }
    });
  
    const weightMapping: any = {
      'Very Easy': 1,
      'Easy': 2,
      'Medium': 3,
      'Hard': 4
    };
    this.formAddQuestion.Weightage = weightMapping[this.formAddQuestion.QuestionLevel] || 0;
  
    const questionData = {
      UnitID: this.formAddQuestion.UnitID,
      ParentQuestionID: null,
      QuestionType: this.formAddQuestion.QuestionType,
      LanguageID: 2,
      Weightage: this.formAddQuestion.Weightage,
      QuestionLevel: this.formAddQuestion.QuestionLevel,
      FormNo: this.formAddQuestion.FormNo,
      QuestionText: this.formAddQuestion.QuestionText,
      VideoLink: this.formAddQuestion.VideoLink || null,
      AudioLink: this.formAddQuestion.AudioLink || null,
      ImageLink: this.formAddQuestion.ImageLink || null,
      IsActive: 1,
    };
    
    let answerDataArray;
    if (this.selectedQuestionType === 'Ordering') {
      const allAnswersText = this.AnswersDTO.map((answer: any) => answer.AnswerText);
      const allImageLinks = this.AnswersDTO.map((answer: any) => answer.ImageLink);
      answerDataArray = [{
        AnswerText: allAnswersText.join(", "),
        IsCorrect: 0,
        ImageLink: allImageLinks.join(", "),
      }];
    } else {
      answerDataArray = this.AnswersDTO.map((answer: any) => ({
        AnswerText: answer.AnswerText,
        IsCorrect: answer.IsCorrect ? 1 : 0,
        ImageLink: answer.ImageLink || null,
      }));
    }
    
    this.qsService.addQuestionItem(questionData, answerDataArray).subscribe((response) => {
      this.getQuestionsBank();
      this.showAddModal = false;
    });
  }
  
  changeLanguage(question: any) {
    this.selectedQuestion = question;
    if(question.Language == 'Arabic') {
      this.qsService.GetQuestionByID(question.ID).subscribe((response) => {
        this.questionLangContent = response?.result?.[0] || [];
        if (this.questionLangContent && this.questionLangContent.length > 0) {
          this.selectedQuestion.Question = this.questionLangContent[0].QuestionText;
          this.selectedQuestion.Language = question.Language;
          this.selectedQuestion.LanguageID = this.questionLangContent[0].LanguageID;
        }
      });
    }

    if(question.Language != 'Arabic') {
      
      this.qsService.getQuestionsByParentID(question.ID, question.Language).subscribe((response) => {
        this.questionLangContent = response?.result?.[0] || [];
        if (this.questionLangContent && this.questionLangContent.length > 0) {
          this.selectedQuestion.Question = this.questionLangContent[0].Question;
          this.selectedQuestion.Language = question.Language;
          this.selectedQuestion.LanguageID = this.questionLangContent[0].LanguageID;
        }

        const selectedLanguage = this.filteredLanguagesList.find((lang: any) => lang.LanguageName === question.Language);
        if (selectedLanguage) {
          this.selectedQuestion.LanguageID = selectedLanguage.LanguageID;
        }

        if(this.questionLangContent.length === 0) {
          this.selectedQuestion.Question = null;
          this.selectedQuestion.Language = question.Language;
          this.selectedQuestion.LanguageID = selectedLanguage?.LanguageID;
          this.selectedQuestion.QuestionID = question.ID
        }

      });
    }
  }

  updateModal(question: any) {
    this.selectedQuestion = { ...question };
    this.selectedQuestion.OriginalID = question.ID; 
    this.selectedQuestion.DisplayedQuestionID = question.ID; 
   
    if (question.Language !== 'Arabic' && this.questionLangContent.length > 0) {
      this.selectedQuestion.DisplayedQuestionID = this.questionLangContent[0].QuestionID;
    }



      this.qsService.getAnswers(this.selectedQuestion.DisplayedQuestionID).subscribe((response) => {
        this.AnswersDTO = response?.result?.[0] || [];
     
    
        if (this.selectedQuestion.QuestionType === 'Ordering') {
          try {
            this.AnswersDTO = this.AnswersDTO.map((answer: any) => {
              const cleanedText = answer.AnswerText.replace(/Ordering\s*/g, '').trim();
              const splitText = cleanedText.split(',').map((text: string) => text.trim());
      
              return splitText.map((word: string, index: number) => ({
                AnswerID: `${answer.AnswerID}_${index}`,
                AnswerText: word,
                IsCorrect: answer.IsCorrect,
              }));
            }).flat();
          } catch (error) {
            this.AnswersDTO = [];
          }
        }

        this.showUpdateModal = true;

        if (this.selectedQuestion.Question == null) {
          this.AnswersDTO = this.AnswersDTO.map((answer: any) => ({
            ...answer,
            AnswerText: answer.AnswerText?.trim() || '',
          }));
        }

    });


  
    const folder = this.FolderDTO.find((f: any) => f.ID === this.selectedQuestion.Fid);
    this.unitCount = folder?.CourseUnitsCount;
  
    if (folder) {
      this.selectedQuestion.FolderName = folder.CourseName;
      this.selectedFolderUnits = folder.UnitsDetails || [];
      const unit = this.selectedFolderUnits.find((u: any) => u.UnitName === this.selectedQuestion.FolderUnit);
      if (unit) {
        this.selectedQuestion.FolderUnit = unit.UnitName;
      }
    }
  
    const level = this.QuestionLevels.find((w: any) => w.name === this.selectedQuestion.QuestionLevel);
    if (level) {
      this.selectedQuestion.QuestionLevel = level.name;
    }

    this.showAddBTN = this.AnswersDTO.length === 0;
    if (this.selectedQuestion.QuestionType === 'MultiAnswers'){
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = true;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }
    
    if (this.selectedQuestion.QuestionType === 'MCQ'){ 
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    } 

    if (this.selectedQuestion.QuestionType === 'TF'){ 
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (this.selectedQuestion.QuestionType === 'MCQImages'){
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = true;
    }

    if (this.selectedQuestion.QuestionType === 'RightOrWrongImage'){
      this.showQuestionImage = true;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (this.selectedQuestion.QuestionType === 'RightOrWrongVideo'){
      this.showQuestionImage = false;
      this.showQuestionVideo = true;
      this.showAnswerText = true;
      this.showAddBTN = false;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if (this.selectedQuestion.QuestionType === 'Ordering'){
      this.showQuestionImage = false;
      this.showQuestionVideo = false;
      this.showAnswerText = true;
      this.showAddBTN = true;
      this.showAnswerAudio = false;
      this.showAnswerVideo = false;
      this.showAnswerImage = false;
    }

    if(this.AnswersDTO.length === 0) {
      if (this.selectedQuestion.QuestionType === 'MultiAnswers'){
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = true;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      }
      
      if (this.selectedQuestion.QuestionType === 'MCQ'){ 
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = false;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      } 
  
      if (this.selectedQuestion.QuestionType === 'TF'){ 
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' }
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = false;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      }
  
      if (this.selectedQuestion.QuestionType === 'MCQImages'){
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' },
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = false;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = true;
      }
  
      if (this.selectedQuestion.QuestionType === 'RightOrWrongImage'){
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' }
        ];
        this.showQuestionImage = true;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = false;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      }
  
      if (this.selectedQuestion.QuestionType === 'RightOrWrongVideo'){
        this.AnswersDTO = [ 
          { AnswerID: 0, AnswerText: '' },
          { AnswerID: 0, AnswerText: '' }
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = true;
        this.showAnswerText = true;
        this.showAddBTN = false;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      }
  
      if (this.selectedQuestion.QuestionType === 'Ordering'){
        this.AnswersDTO = [ 
          { AnswerText: '' },
          { AnswerText: '' },
          { AnswerText: '' },
          { AnswerText: '' },
        ];
        this.showQuestionImage = false;
        this.showQuestionVideo = false;
        this.showAnswerText = true;
        this.showAddBTN = true;
        this.showAnswerAudio = false;
        this.showAnswerVideo = false;
        this.showAnswerImage = false;
      }
    }

  }

  isUpdateFormInvalid(): boolean {
    return !this.selectedQuestion.Question || 
            this.AnswersDTO.length === 0 || 
            this.AnswersDTO.some((a: { AnswerText: any; }) => !a.AnswerText);

  }
  
  updateQuestionItem() {

    if(this.selectedQuestion.Language === 'Arabic') {
      const updateQuestionData = {
        QuestionID: this.selectedQuestion.ID,
        Question: this.selectedQuestion.Question,
        VideoLink: this.selectedQuestion.VideoLink,
        ImageLink: this.selectedQuestion.ImageLink,
      };

      if (this.selectedQuestion.QuestionType === 'Ordering') {
        const allAnswersText = this.AnswersDTO.map((answer: any) => answer.AnswerText);
        const answerID = this.AnswersDTO.map((answer: any) => answer.AnswerID);
        this.AnswersDTO = [{
          AnswerID: answerID[0],
          AnswerText: "Ordering "+allAnswersText,
          IsCorrect: 0,
          ImageLink: null,
        }];
      }else{
        this.AnswersDTO.map((answer: any) => ({
          AnswerID: answer.AnswerID,
          AnswerText: answer.AnswerText,
          IsCorrect: answer.IsCorrect ? 1 : 0,
          ImageLink: answer.ImageLink|| null,
        }));
      }

      this.qsService.updateQuestionItem(updateQuestionData, this.AnswersDTO).subscribe((response) => {
        this.getQuestionsBank();
        this.showUpdateModal = false;
      });
    } 

    if (this.selectedQuestion.Language !== 'Arabic') {
      this.qsService.getQuestionsByParentID(this.selectedQuestion.ID, this.selectedQuestion.Language).subscribe({
        next: (response) => {
          this.questionLangContent = response?.result?.[0] || [];
          const addQuestion = {
            UnitID: this.selectedQuestion.UnitID,
            ParentQuestionID: this.selectedQuestion.ID,
            QuestionType: this.selectedQuestion.QuestionType,
            LanguageID: this.selectedQuestion.LanguageID,
            Weightage: this.selectedQuestion.Weightage,
            QuestionLevel: this.selectedQuestion.QuestionLevel,
            FormNo: this.selectedQuestion.FormNo,
            QuestionText: this.selectedQuestion.Question,
            VideoLink: this.selectedQuestion.VideoLink || null,
            AudioLink: this.selectedQuestion.AudioLink || null,
            ImageLink: this.selectedQuestion.ImageLink || null,
            IsActive: 1,
          };

          if (this.selectedQuestion.QuestionType === 'Ordering') {
            const allAnswersText = this.AnswersDTO.map((answer: any) => answer.AnswerText);
            const answerID = this.AnswersDTO.map((answer: any) => answer.AnswerID);
            this.AnswersDTO = [{
              AnswerID: answerID[0],
              AnswerText: "Ordering "+allAnswersText,
              IsCorrect: 0,
              ImageLink: null,
            }];
          }else{
            this.AnswersDTO.map((answer: any) => ({
              AnswerID: answer.AnswerID,
              AnswerText: answer.AnswerText,
              IsCorrect: answer.IsCorrect ? 1 : 0,
              ImageLink: answer.ImageLink|| null,
            }));
          }

        if (!this.questionLangContent || this.questionLangContent.length === 0) { 
            this.qsService.addQuestionItem(addQuestion, this.AnswersDTO).subscribe((response) => {
              this.getQuestionsBank();
              this.showUpdateModal = false;
            });

        }else{
            const updateQuestionData = {
              QuestionID: this.questionLangContent[0].QuestionID,
              Question: this.selectedQuestion.Question,
              VideoLink: this.selectedQuestion.VideoLink || null,
              ImageLink: this.selectedQuestion.ImageLink|| null,
            };

            if (this.selectedQuestion.QuestionType === 'Ordering') {
              const allAnswersText = this.AnswersDTO.map((answer: any) => answer.AnswerText);
              const answerID = this.AnswersDTO.map((answer: any) => answer.AnswerID);
              this.AnswersDTO = [{
                AnswerID: answerID[0],
                AnswerText: "Ordering "+allAnswersText,
                IsCorrect: 0,
                ImageLink: null,
              }];
            }else{
              this.AnswersDTO.map((answer: any) => ({
                AnswerID: answer.AnswerID,
                AnswerText: answer.AnswerText,
                IsCorrect: answer.IsCorrect ? 1 : 0,
                ImageLink: answer.ImageLink|| null,
              }));
            }

            this.qsService.updateQuestionItem(updateQuestionData, this.AnswersDTO).subscribe((response) => {
              this.getQuestionsBank();
              this.showUpdateModal = false;
            });
          }
        }
      });
    }
  }
  
  closeModal() {
    this.selectedQuestion = null;
    this.AnswersDTO = [];
    this.showUpdateModal = false;
    this.showAddModal = false;
    this.showViewModal = false;
    this.showDeleteModal = false;
  }

  addAnswer() {

    const newAnswer = {
      AnswerID: 0,
      AnswerText: '',
      ImageLink: '',
    };
  
    this.AnswersDTO.push(newAnswer);
  
    const maxAnswers: { [key: string]: number } = {
      MultiAnswers: 4,
      MCQ: 3,
      MCQImages: 3,
      Ordering: 5
    };
  
    this.showAddBTN = this.AnswersDTO.length <= (maxAnswers[this.selectedQuestionType || this.selectedQuestion.QuestionType] || 3);
    this.showRemoveBTN = true;
  }
  
  removeAnswer(index: number) {
    this.AnswersDTO.splice(index, 1);
  
    const maxAnswers: { [key: string]: number } = {
      MultiAnswers: 4,
      MCQ: 3,
      MCQImages: 3,
      Ordering: 5
    };
  
    this.showAddBTN = this.AnswersDTO.length <= (maxAnswers[this.selectedQuestionType || this.selectedQuestion.QuestionType] || 3);
    this.showRemoveBTN = this.AnswersDTO.length >= maxAnswers[this.selectedQuestionType || this.selectedQuestion.QuestionType];
  }
  
  get totalPages(): number {
    return Math.ceil(this.TotalQuestions / this.itemsPerPage);
  }

  deleteQuestionItem(question: any) {
    this.selectedQuestion = question;
    this.showDeleteModal = true;  
  }
  
  confirmDeletion() {
    this.qsService.deleteQuestionItem(this.selectedQuestion.ID).subscribe((response) => {
      this.getQuestionsBank();  
    });
    this.showDeleteModal = false;  
  }
  
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.applyFilters();
    }
  }
  
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.applyFilters();
    }
  }
  
  applyFilters() {
    if (this.searchFolder || this.searchUnit || this.searchType || this.searchLevel) {
      this.searchFilters();
    } else {
      this.getQuestionsBank();
    }
  }
  
  searchFilters() {
    this.qsService.filteredQuestionBank(this.currentPage, this.itemsPerPage,this.searchFolder, this.searchUnit, this.searchType, this.searchLevel)
      .subscribe((response) => {
        this.qusetionBank = response.result[0];
      });
  }

  resetFilters() {
    this.searchText = ''
    this.searchFolder = ''
    this.searchUnit = ''
    this.searchType = ''
    this.searchLevel = ''
    this.getQuestionsBank()
  }
}
